export default __webpack_public_path__ + "static/media/csv.da9035aa.svg";